import React, { useEffect, useState } from "react";
import ContentPageTitle from "../../../../common/ContentPageTitle";
import { useManagementOrders } from "../../../../hooks/useManagementOrders";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import OrderSettings from "./OrderSettings";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import { Tabs, Spin } from "antd";

export default function ManageOrders(props) {
  const { business } = props;
  const user = useSelector((state) => state.user.user);

  const [ordersList, setOrdersList] = useState({
    shippedOrders: [],
    pendingPaymentOrders: [],
    completedOrders: [],
    canceledOrders: [],
    processingOrders: [],
    readyOrders: [],
  });

  const [loading, setLoading] = useState(true);

  const getAllOrders = async () => {
    setLoading(true);
    const APIURL = `/api/restaurant/order/allOrdersFromRestaurant/${business.id}`;

    try {
      const res = await axiosWithAuth().get(APIURL);
      setOrdersList(res.data.data);
    } catch (err) {
      console.log(err.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllOrders();
  }, [business.id]);

  const [ListComponent] = useManagementOrders(getAllOrders);

  return (
    <div id="restaurant-page">
      <ContentPageTitle title="Manage Orders" icon="file-pen" />

      <div className="content-box">
        <Routes>
          <Route
            path="/"
            element={
              <Spin spinning={loading}>
                <Tabs defaultActiveKey="1" type="card" size="default">
                  <Tabs.TabPane tab="Processing Orders" key="1">
                    <ListComponent
                      emptyMessage="Seems like you don't have an orders listing."
                      listItems={ordersList.processingOrders || []}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Ready Orders" key="2">
                    <ListComponent
                      emptyMessage="Seems like you don't have an orders listing."
                      listItems={ordersList.readyOrders || []}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="On the way" key="3">
                    <ListComponent
                      emptyMessage="Seems like you don't have an orders listing."
                      listItems={ordersList.shippedOrders || []}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Completed Orders" key="4">
                    <ListComponent
                      emptyMessage="Seems like you don't have an orders listing."
                      listItems={ordersList.completedOrders || []}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Canceled Orders" key="5">
                    <ListComponent
                      emptyMessage="Seems like you don't have an orders listing."
                      listItems={ordersList.canceledOrders || []}
                    />
                  </Tabs.TabPane>
                </Tabs>
              </Spin>
            }
            exact
          />

          <Route
            path="/:id"
            element={<OrderSettings business={business} ordersList={ordersList} />}
            exact
          />
        </Routes>
      </div>
    </div>
  );
}
